<template>
  <div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },


    computed: {

    },

    mounted () {

    },

    methods: {


    }
  }
</script>


<style lang='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/views/course/courseDetail.vue